export * from './compare-table-header.interface';
export * from './compare-table-item-content.interface';
export * from './compare-table-item.interface';
export * from './compare-table-label.interface';
export * from './compare-table.interface';
